<!-- Loader -->
<div *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm">
  <i class="fas fa-spinner fa-spin text-6xl" style="color:#c19725;"></i>
</div>

<div class="w-full py-3 px-4">
  <div class="sm:flex items-center justify-between mb-4 bg-white p-3 rounded-lg shadow-sm border border-gray-100">
    <div class="flex items-center gap-3">
      <span class="font-bold text-lg sm:text-xl text-gray-800">{{ showHistoryModal ? 'Transaction History' : 'Order
        List' }}</span>
    </div>
    <div class="flex items-center gap-3 mt-2 sm:mt-0">
      <div *ngIf="!showHistoryModal" class="relative w-full sm:w-[220px]">
        <select [(ngModel)]="selectedStatus"
          class="w-full capitalize cursor-pointer border border-gray-300 text-gray-700 font-semibold text-sm rounded-lg py-2 pl-3 pr-10 bg-gray-50 hover:bg-white focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all shadow-sm">
          <option value="all">All Orders</option>
          <option value="delivered">Delivered Orders</option>
          <option value="pending">Pending Orders</option>
          <option value="rejected">Rejected Orders</option>
        </select>
        <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none">
          <i class="fas fa-chevron-down text-gray-400 text-xs"></i>
        </div>
      </div>
      <button (click)="toggleHistoryModal()"
        [ngClass]="showHistoryModal ? 'bg-indigo-600 text-white hover:bg-indigo-700' : 'bg-indigo-50 text-indigo-700 hover:bg-indigo-100'"
        class="flex items-center gap-2 px-4 py-2 rounded-lg transition-all border border-indigo-100 active:scale-95 shadow-sm"
        title="View Transaction History">
        <i class="fas" [ngClass]="showHistoryModal ? 'fa-list-ul' : 'fa-history'"></i>
        <span class="text-xs font-bold uppercase tracking-wider">{{ showHistoryModal ? 'Show Orders' : 'History'
          }}</span>
      </button>
    </div>
  </div>

  <div *ngIf="showHistoryModal" class="animate-in fade-in slide-in-from-top-4 duration-300">
    <!-- Filters -->
    <div class="flex flex-wrap items-center gap-4 mb-6 bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
      <div class="flex flex-col">
        <label class="text-[10px] uppercase text-indigo-600 font-black mb-1.5 tracking-wider">From Date</label>
        <input type="date" [(ngModel)]="fromDate" (change)="getKalakarTransactions()"
          class="text-sm border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none bg-white transition-all shadow-sm">
      </div>
      <div class="flex flex-col">
        <label class="text-[10px] uppercase text-indigo-600 font-black mb-1.5 tracking-wider">To Date</label>
        <input type="date" [(ngModel)]="toDate" (change)="getKalakarTransactions()"
          class="text-sm border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 outline-none bg-white transition-all shadow-sm">
      </div>
      <div class="flex items-end h-full self-end gap-2 ml-auto">
        <button (click)="getKalakarTransactions()"
          class="px-6 py-2 bg-indigo-600 text-white text-sm font-bold rounded-lg shadow-md hover:bg-indigo-700 hover:shadow-lg active:scale-95 transition-all">
          Apply Filter
        </button>
        <button (click)="clearTransactionsFilter()"
          class="px-6 py-2 bg-white text-gray-700 text-sm font-bold rounded-lg border border-gray-300 hover:bg-gray-50 active:scale-95 transition-all shadow-sm">
          Clear
        </button>
      </div>
    </div>

    <!-- Table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 shadow-sm mb-6 bg-white text-[11px]">
      <table class="min-w-full text-sm">
        <thead
          class="bg-gray-50 text-gray-600 uppercase text-[11px] font-black tracking-widest border-b border-gray-200">
          <tr>
            <th class="p-4 text-left">Date & Time</th>
            <th class="p-4 text-left">Type</th>
            <th class="p-4 text-left">Code</th>
            <th class="p-4 text-left">Product</th>
            <th class="p-4 text-left">Qty</th>
            <th class="p-4 text-left">Amount</th>
            <th class="p-4 text-left">Remarks</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          <tr *ngFor="let tx of transactions" class="hover:bg-indigo-50/30 transition-colors">
            <td class="p-4 text-gray-900 font-semibold whitespace-nowrap">
              {{ tx.created_at | date: 'dd-MMM-yyyy hh:mm a' }}
            </td>
            <td class="p-4">
              <span [ngClass]="{
                'bg-blue-100 text-blue-700 border border-blue-200': tx.ot_type === 'order_assigned',
                'bg-orange-100 text-orange-700 border border-orange-200': tx.ot_type === 'stock_handed_over',
                'bg-green-100 text-green-700 border border-green-200': tx.ot_type === 'quantity_approved',
                'bg-red-100 text-red-700 border border-red-200': tx.ot_type === 'quantity_rejected',
                'bg-emerald-100 text-emerald-700 border border-emerald-200': tx.ot_type === 'labour_paid',
                'bg-amber-100 text-amber-700 border border-amber-200': tx.ot_type === 'return_requested',
                'bg-yellow-100 text-yellow-700 border border-yellow-200': tx.ot_type === 'submitted_for_approval',
                'bg-indigo-100 text-indigo-700 border border-indigo-200': tx.ot_type === 'return_approved'
              }" class="px-2.5 py-1 rounded-md text-[10px] font-black uppercase tracking-wider">
                {{ formatTransactionType(tx.ot_type) }}
              </span>
            </td>
            <td class="p-4 font-mono text-xs font-black text-indigo-600 uppercase">
              {{ tx.ot_product_code }}
            </td>
            <td class="p-4 font-medium text-gray-700">
              {{ tx.ot_product_name }}
            </td>
            <td class="p-4 font-black text-gray-900">
              {{ tx.ot_quantity }}
            </td>
            <td class="p-4 font-black text-emerald-600">
              <span *ngIf="tx.ot_amount > 0">₹{{ tx.ot_amount }}</span>
              <span *ngIf="!tx.ot_amount || tx.ot_amount <= 0" class="text-gray-300">—</span>
            </td>
            <td class="p-4 italic text-gray-500 max-w-xs truncate" [title]="tx.ot_remarks">
              {{ tx.ot_remarks || '—' }}
            </td>
          </tr>
          <tr *ngIf="!isLoadingHistory && transactions.length === 0">
            <td colspan="7" class="p-12 text-center text-gray-400 font-medium italic bg-gray-50">
              No transactions found for the selected period
            </td>
          </tr>
          <tr *ngIf="isLoadingHistory">
            <td colspan="7" class="p-12 text-center bg-gray-50">
              <div class="flex flex-col items-center gap-3">
                <div class="w-10 h-10 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin">
                </div>
                <span class="text-xs text-indigo-600 font-black uppercase tracking-widest animate-pulse">Loading
                  History...</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div *ngIf="totalTransactions > pageSize"
      class="flex flex-col sm:flex-row items-center justify-between gap-4 p-4 bg-white rounded-xl border border-gray-100 shadow-sm">
      <div class="text-xs text-gray-500 font-bold uppercase tracking-wider">
        Showing <span class="text-gray-900">{{ (currentPage - 1) * pageSize + 1 }}</span> -
        <span class="text-gray-900">{{ Math.min(currentPage * pageSize, totalTransactions) }}</span> of
        <span class="text-gray-900">{{ totalTransactions }}</span> records
      </div>
      <div class="flex items-center gap-4">
        <span class="text-xs font-black text-gray-400 uppercase tracking-widest">Page {{ currentPage }} / {{
          lastPage }}</span>
        <div class="flex gap-2">
          <button [disabled]="currentPage === 1" (click)="getKalakarTransactions(currentPage - 1)"
            class="px-5 py-2 border border-gray-300 rounded-lg text-xs font-black uppercase tracking-tighter bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm active:scale-95">
            Previous
          </button>
          <button [disabled]="currentPage >= lastPage" (click)="getKalakarTransactions(currentPage + 1)"
            class="px-5 py-2 border border-gray-300 rounded-lg text-xs font-black uppercase tracking-tighter bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-sm active:scale-95">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!showHistoryModal" [ngSwitch]="selectedStatus">
    <app-all-orders *ngSwitchCase="'all'" [orders]="allOrders" (orderUpdated)="onOrderUpdated($event)"></app-all-orders>
    <app-rejected-orders *ngSwitchCase="'rejected'" [orders]="rejectedOrders"
      (orderUpdated)="onOrderUpdated($event)"></app-rejected-orders>
    <app-pending-orders *ngSwitchCase="'pending'" [orders]="pendingOrders"
      (orderUpdated)="onOrderUpdated($event)"></app-pending-orders>
    <app-delivered-orders *ngSwitchCase="'delivered'" [orders]="deliveredOrders"
      (orderUpdated)="onOrderUpdated($event)"></app-delivered-orders>
  </ng-container>
</div>